import 'css-chunksrc/client/pages/projectPage/wbsPage/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_lqivn_1",
  "button": "_button_lqivn_5",
  "icon": "_icon_lqivn_25",
  "iconBox": "_iconBox_lqivn_33",
  "menu": "_menu_lqivn_42",
  "menuItem": "_menuItem_lqivn_54",
  "menuText": "_menuText_lqivn_67"
};